module.exports = __webpack_public_path__ + "img/ai-compare-history-delete.e5246013.svg";